module.exports = __webpack_public_path__ + "img/01.44349af6.jpg";